import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Toast from '../toast'
import qs from 'qs'

Vue.use(VueAxios, axios)

export default Vue.component(
  'transfer-pet',
  {
    props: ['isPending'],
    data () {
      return {
        transferPending: (this.isPending || '').toString() === '1',
        showModal: false,
        showFailureMessage: false,
        errorMessage: '',
        loading: false,
        errors: {},
        validationErrors: false,
        fields: {
          newGuardianEmail: '',
          newGuardianFirstName: '',
          newGuardianSurname: '',
          newGuardianNumber: '',
          newGuardianAltNumber: ''
        }
      }
    },
    methods: {
      confirmTransfer (id, token) {
        const url = '/my-companion-animals/transfer/' + id
        this.loading = true
        this.errorMessage = ''
        this.errors = {}
        this.validationErrors = false
        this.axios({
          method: 'POST',
          url,
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: qs.stringify({
            id: id,
            FormToken: token,
            email: this.fields.newGuardianEmail,
            firstName: this.fields.newGuardianFirstName,
            surname: this.fields.newGuardianSurname,
            number: this.fields.newGuardianNumber,
            altNumber: this.fields.newGuardianAltNumber
          }),
          maxRedirects: 0
        }).then(() => {
          this.loading = false
          this.transferPending = true
          this.$root.transferPending = true
          this.showModal = false
          this.$toast.success({
            component: Toast,
            props: {
              heading: 'Re-home initiated',
              body: 'An email has been sent to the new guardian to advise them of the transfer.'
            }
          })
        }).catch((error) => {
          this.errors = error?.response?.data?.errors
          this.errorMessage = error?.response?.data?.errors?.[0]?.value || 'An error has occurred, please reload or try again later'
          this.loading = false
          this.showModal = true

          const errorValues = Object.values(this.errors) ?? []
          if (errorValues.length > 0) {
            errorValues.forEach(error => {
              if (error?.type === 'validation') {
                this.validationErrors = true
              }
            })
          }

          this.showFailureMessage = !this.validationErrors
        })
      },
      clearModal () {
        this.showModal = false
        this.errorMessage = ''
        this.showFailureMessage = false
        this.errors = {}
        this.validationErrors = false
      }
    }
  }
)
